<template>
  <div>
    <Historys :item="item" :fields="fields" :childrenFields="childrenFields"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Historys from "@/projects/views/E-Performances/Management/Agency/components/Historys";
export default {
  name: "Affiliations",
  components: {Historys},
  data: function () {
    return {
      item:[],
      fields :[
        {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
        {key:"title", label:"Name"},
        {key:"total", label: "Total", _style: 'width:30px; text-align: center'},
        {key:"action", label: "#", _style: 'width:30px; text-align: center'}
      ],
      childrenFields :[
        {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
        {key:"title", label:"Name"},
        // {key:"position", label:"Position"},
        // {key:"dateTime", label:"Start Date"},
        // {key:"experiences", label:"Experience", _style: 'width:220px; text-align: center'},
        {key:"action", label: "#", _style: 'width:30px; text-align: center'}


      ]
    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      // this.$store.dispatch("affiliation/config",{})
      var body = {};
      body.group = true;
      this.$store.dispatch("agency/config",body)
    },

    onLoad() {

    },

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      agency: 'agency/item',
    })
  },

  watch: {

    agency: function (value) {
      this.item = [];
      var lang = this.$store.getters['setting/lang']
      value.filter(item => {
        item.title = item.title.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;

        item.total = item.item.length;

        // change object
        item.item.filter(h => {
          h.code = h.accounts.code;
          h.title = h.accounts.userinfo.prefix.filter(title => {
            if (title.key == lang) {
              return title
            }
          })[0].value+' '+h.accounts.userinfo.firstName.filter(title => {
              if (title.key == lang) {
                return title
              }
            })[0].value+' '+h.accounts.userinfo.lastName.filter(title => {
            if (title.key == lang) {
              return title
            }
          })[0].value;
          // h.dateTime = h.experience.filter(objs => {
          //   return (objs.type == "000000000000000000000000")
          // })[0].startDate
          //
          // const startDate = moment(h.dateTime);
          // const endDate = moment();
          // const yearsDiff = endDate.diff(startDate, 'years');
          // const monthsDiff = endDate.diff(startDate, 'months') % 12;
          //
          // try {
          //
          //   h.position = h.fields[h.fields.length -1].personnelType.title.filter(title => {
          //     if (title.key == lang) {
          //       return title
          //     }
          //   })[0].value
          // }catch (e) {
          //   h.position = ""
          // }
          //
          // h.experiences = ` ${yearsDiff} ปี ${monthsDiff} เดือน`


          return h;
        })

        return item;
      })
      if( this.$store.getters["personal/profile"].role != 1){
        this.item = value.filter(objs =>  { return (objs._id.toString() == this.$store.getters["personal/profile"].agency._id)});
      }else{
        this.item = value
      }
    },

  }
}
</script>

<style scoped>

</style>
